import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import axios from "axios";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import profile_img from "../../assets/avatar_placeholder.svg";
import { useLocalStorage } from "../../hooks";
import { useToast } from "../../provider/ToastProvider";
import { clearDashboardData } from "../../redux/reducers/dashboardReducer";
import { setActionLoading } from "../../redux/reducers/loadingReducer";
import { clearSchoolData } from "../../redux/reducers/schoolReducer";
import * as userActions from "../../redux/reducers/userReducer";
import { userState } from "../../redux/reducers/userReducer";
import { getUrlForUsers } from "../../utils/confighelpers";
import { TwInitialsAvatar } from "../tailwind";

/**
 * Page frame with a header and the account menu (Logout), used by the phone verification step and the subscription
 * pages. Moved here unchanged from the old onboarding wizard (modals/signup/onbording), which was removed on 2026-10-28.
 */
export function OnBordingBaseLayout(props) {
  const { children, className = "", title, logoutCallBack, showHeadMenu = true } = props
  const { addToast, addSuccessToast, addErrorToast } = useToast();
  const navigate = useNavigate();
  const userReduxState = useSelector(userState);
  const dispatch = useDispatch();
  const [userToken, setUserToken] = useLocalStorage("userToken");
  const headerprofile = userReduxState && userReduxState.onBoardingData && Object.keys(userReduxState.onBoardingData).length > 0 ? userReduxState.onBoardingData : (userReduxState.userData !== null ? userReduxState.userData : {})

  const userNavigation = [
    {
      label: "Logout",
    }
  ]
  const userFullname = () => {
    let splitName = (headerprofile?.fullName || "")?.split(' ');
    let fullname = splitName.length ? splitName[0] : []
    if (splitName.length > 1) {
      fullname += " " + splitName[1].substring(0, 1) + "."
    }
    return fullname;
  };

  const logout = async () => {
    addToast("Logging out...");
    try {

      dispatch(setActionLoading(true));
      await axios.put(
        `${getUrlForUsers()}logoutUser`,
        {},
        {
          headers: {
            "Content-Type": "application/json",
            "x-access-token": userToken,
          },
        }
      );
      dispatch(setActionLoading(false));
    } catch (err) {
      console.log("error", err);
    } finally {
      localStorage.removeItem("userToken");
      localStorage.removeItem("persist:root");
      dispatch(userActions.clearUserData());
      dispatch(clearSchoolData());
      dispatch(clearDashboardData());
      await setUserToken("");
      // navigate("/", { replace: true });
      window.location.href = "/";
    }
  };

  return (<div className="flex flex-col min-h-screen overflow-y-auto">
    <div className="sticky top-0 z-40 flex flex-row justify-between items-center shrink-0ß gap-x-4 border-b border-gray-200 bg-white shadow-md sm:gap-x-6 px-4 sm:px-6 lg:px-8 py-4 sm:py-6">
      {typeof title == "string" ? (<h4
        className={
          "text-brown-coffee m-4 md:m-6  lg:my-6 lg:mx-16 font-bold text-2xl md:text-3xl flex-1"
        }
      >
        {title}
      </h4>) : (
        <div className="flex-1">
          {title}
        </div>)}
      {/* <TwButton
        className="shrink-0"
        onClick={async () => {
          await logout()
          if (logoutCallBack) {
            await logoutCallBack()
          }
        }}
      >
        Start Over
      </TwButton> */}
      {showHeadMenu && (<Menu as="div" className="relative">
        <MenuButton className="-m-1.5 flex items-center p-1.5 rounded-full bg-zinc-300">
          <span className="sr-only">Open user menu</span>
          {headerprofile?.profilePic ? (<img
            className={"xs:size-6 size-7 md:size-8 lg:size-9 rounded-full bg-gray-50"}
            alt="" src={headerprofile?.profilePic ?? profile_img} />) : (
            <TwInitialsAvatar name={userFullname()} />
          )}
          <span className="hidden lg:flex lg:items-center">
            <span aria-hidden="true" className="ml-4 text-sm/6 font-semibold text-gray-900">
              {userFullname()}
            </span>
            <ChevronDownIcon aria-hidden="true" className="ml-2 size-5 text-gray-400" />
          </span>
        </MenuButton>
        <MenuItems
          transition
          className="absolute right-0 z-10 mt-2.5 [min-w-36] min-w-0 flex-auto origin-top-right rounded-md bg-white py-2 ring-1 shadow-lg ring-gray-900/5 transition focus:outline-hidden data-closed:scale-95 data-closed:transform data-closed:opacity-0 data-enter:duration-100 data-enter:ease-out data-leave:duration-75 data-leave:ease-in"
        >
          {userNavigation.map((item) => (
            <MenuItem key={item.label}>
              <button
                onClick={async () => {
                  // handleCloseUserMenu();
                  if (item.label === "Logout") {
                    return await logout();
                  } else {
                    navigate(item.navigate.to, {
                      state: item.navigate.state,
                    });
                  }
                }}
                className="truncate w-full px-3 py-1 text-start text-sm/6 text-gray-900 hover:bg-gray-50 hover:outline-hidden focus:bg-gray-50 focus:outline-hidden"
              >
                {item.label}
              </button>
            </MenuItem>
          ))}
        </MenuItems>
      </Menu>)}
    </div>
    {children}
  </div>)
}
